"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazyIconFactory = exports.IconBox = void 0;
const Icon_1 = require("./Icon");
Object.defineProperty(exports, "IconBox", { enumerable: true, get: function () { return Icon_1.IconBox; } });
Object.defineProperty(exports, "lazyIconFactory", { enumerable: true, get: function () { return Icon_1.lazyIconFactory; } });
